<template>
  <tela-component title="Relatório Posição Contratos">
    <v-card flat rounded="lg">
      <v-card-text>
        <template>
          <selecionar-vendedor-relat />

          <v-select
            label="Tipo Relatório"
            :items="tiposRelat"
            item-text="descricao"
            item-value="cod"
            no-data-text="Nenhum tipo de relatório encontrado"
            v-model="tipoRelatSelec"
          ></v-select>
          <v-btn rounded block color="info" depressed @click="gerarRelatorio()"
            >Gerar Relatório</v-btn
          >
        </template>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import { mapState } from "vuex";
import TelaComponent from "../tela/TelaComponent.vue";
import SelecionarVendedorRelat from "./SelecionarVendedorRelat.vue";
export default {
  components: { TelaComponent, SelecionarVendedorRelat },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
  },
  data: () => ({
    tiposRelat: [
      { cod: 1, descricao: "Geral" },
      { cod: 2, descricao: "Por Produto" },
    ],
    tipoRelatSelec: 1,    
  }),
  methods: {
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/nutricao-animal/clientes/produtos-em-aberto?token=${this.usuarioLogado.token}&sync=true&output=PDF&tiporelat=${this.tipoRelatSelec}&cod_vendedor=${this.vendedorSelecionado}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>